<form
  class="pu-awards-form__form"
  (ngSubmit)="send()"
>
  @if (teamAwards().length) {
    <ul class="pu-awards-form__users">
      @for (group of awardsForm.controls; track $index) {
        <li
          class="pu-awards-form__user"
          [formGroup]="group"
        >
          <div class="pu-awards-form__user-profile">
            <a
              [routerLink]="['/colleague', group.value.colleagueId]"
              (click)="close()"
            >
              <pu-user-profile-card
                [user]="teamAwards()[$index].colleague"
                [hasEmail]="false"
              />
            </a>

            <pu-select
              formControlName="awardId"
              [items]="teamAwards()[$index].awards"
              [label]="'personalInfo.teamBonuses.awardsForm.selectAward' | translate"
              (click)="onSelectClick(group.value.colleagueId)"
            />
          </div>

          <button
            class="pu-awards-form__user-btn"
            type="button"
            puButton
            size="s"
            uiType="secondary"
            (click)="toggleComment($index, group.value.colleagueId)"
          >
            {{
              'personalInfo.teamBonuses.awardsForm.button.' + (commentsState[$index]
                ? 'hideComment' : 'addComment') | translate
            }}
          </button>

          @if (commentsState[$index]) {
            <div class="pu-awards-form__user-comment">
              <pu-text-area
                [maxLength]="200"
                [rows]="3"
                formControlName="comment"
                [label]="'personalInfo.teamBonuses.awardsForm.comment' | translate"
              />

              <div class="pu-awards-form__user-comment-symbols">
                {{ 'personalInfo.teamBonuses.awardsForm.symbols' | translate }} {{
                  group.value.comment.length
                }}/200
              </div>
            </div>
          }
        </li>
      }
    </ul>
  }

  <div class="pu-awards-form__actions">
    <button
      type="submit"
      puButton
      size="l"
      uiType="primary"
      [disabled]="awardsForm.invalid"
    >
      {{ 'personalInfo.teamBonuses.awardsForm.button.sendAward' | translate }}
    </button>

    <button
      type="button"
      puButton
      size="l"
      uiType="secondary"
      (click)="close()"
    >
      {{ 'personalInfo.teamBonuses.awardsForm.button.cancel' | translate }}
    </button>
  </div>
</form>
